<div class="ticket-development flex flex-column gap-4">

  <!-- ─── Seção: Requisitos ─────────────────────────────────────────────── -->
  <div class="flex flex-column gap-2">
    <div class="flex justify-content-between align-items-center">
      <span class="flex align-items-center gap-2 text-sm font-semibold text-color-secondary">
        <i class="pi pi-list text-sm"></i>
        Requisitos ({{ requirements().length }})
      </span>
      @if (canWrite) {
        <p-button
          icon="pi pi-plus"
          label="Adicionar Requisito"
          size="small"
          [disabled]="loadingReqs()"
          (click)="openRequirementDialog()" />
      }
    </div>

    @if (loadingReqs()) {
      <div class="flex flex-column gap-2">
        <p-skeleton height="38px" />
        <p-skeleton height="38px" />
      </div>
    } @else if (requirements().length === 0) {
      <div class="flex align-items-center gap-2 p-3 surface-50 border-1 border-dashed surface-border border-round text-color-secondary text-sm">
        <i class="pi pi-inbox text-base opacity-50"></i>
        <span>Nenhum Requisito cadastrado</span>
      </div>
    } @else {
      <div class="dev-list">
        @for (item of requirements(); track item.id) {
          <div class="dev-item">
            <div class="dev-item-top">
              <div class="dev-item-content">
                <div class="dev-item-main-row">
                  <span class="dev-item-title">{{ item.requirement?.description }}</span>
                  @if (item.requirement?.complexity != null) {
                    <p-tag
                      [value]="getComplexityLabel(item.requirement!)"
                      [severity]="getComplexitySeverity(item.requirement!.complexity)"
                      size="small" />
                  }
                </div>
              </div>
              @if (canWrite) {
                <div class="dev-item-actions">
                  <p-button
                    icon="pi pi-trash"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="danger"
                    pTooltip="Remover requisito"
                    tooltipPosition="top"
                    (click)="confirmDeleteRequirement(item.id)" />
                </div>
              }
            </div>
            @if (item.user?.name) {
              <div class="dev-item-meta-row">
                <span>
                  <i class="pi pi-user"></i>
                  {{ item.user!.name }}
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- ─── Seção: ID Commits ─────────────────────────────────────────────── -->
  <div class="flex flex-column gap-2">
    <div class="flex justify-content-between align-items-center">
      <span class="flex align-items-center gap-2 text-sm font-semibold text-color-secondary">
        <i class="pi pi-code text-sm"></i>
        ID Commits ({{ revisions().length }})
      </span>
      @if (canWrite) {
        <p-button
          icon="pi pi-plus"
          label="Adicionar Commit"
          size="small"
          [disabled]="loadingRevs()"
          (click)="openAddCommitDialog()" />
      }
    </div>

    @if (loadingRevs()) {
      <div class="flex flex-column gap-2">
        <p-skeleton height="38px" />
        <p-skeleton height="38px" />
      </div>
    } @else if (revisions().length === 0) {
      <div class="flex align-items-center gap-2 p-3 surface-50 border-1 border-dashed surface-border border-round text-color-secondary text-sm">
        <i class="pi pi-inbox text-base opacity-50"></i>
        <span>Nenhum ID Commit cadastrado</span>
      </div>
    } @else {
      <div class="dev-list">
        @for (rev of revisions(); track rev.id) {
          <div class="dev-item">
            <div class="dev-item-top">
              <div class="dev-item-content">
                <div class="dev-item-main-row">
                  <span class="dev-item-commit-id"
                        pTooltip="Copiar ID completo"
                        tooltipPosition="top"
                        (click)="copyToClipboard(rev.id_commit!)"
                        style="cursor: pointer;">
                    {{ rev.id_commit! | slice:0:7 }}
                  </span>
                  @if (rev.version) {
                    <p-tag [value]="'v' + rev.version" severity="info" size="small" />
                  }
                </div>
                @if (rev.observation) {
                  <div class="dev-item-desc-row">{{ rev.observation }}</div>
                }
              </div>
              @if (canWrite) {
                <div class="dev-item-actions">
                  <p-button
                    icon="pi pi-pencil"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="secondary"
                    pTooltip="Editar commit"
                    tooltipPosition="top"
                    (click)="openEditCommitDialog(rev)" />
                  <p-button
                    icon="pi pi-trash"
                    [text]="true"
                    [rounded]="true"
                    size="small"
                    severity="danger"
                    pTooltip="Excluir commit"
                    tooltipPosition="top"
                    (click)="confirmDeleteCommit(rev.id!)" />
                </div>
              }
            </div>
            @if (rev.date || rev.user?.name) {
              <div class="dev-item-meta-row">
                @if (rev.user?.name) {
                  <span>
                    <i class="pi pi-user"></i>
                    {{ rev.user!.name }}
                  </span>
                }
                @if (rev.date) {
                  <span class="dev-item-meta-right">
                    <i class="pi pi-calendar"></i>
                    {{ formatDate(rev.date) }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

</div>

<!-- ─── Dialog: Adicionar Requisito ─────────────────────────────────────────── -->
<p-dialog
  [visible]="showRequirementDialog()"
  (visibleChange)="showRequirementDialog.set($event)"
  header="Adicionar Requisito"
  [modal]="true"
  [style]="{ width: '480px', maxWidth: 'calc(100vw - 2rem)' }"
  [breakpoints]="{ '768px': '95vw' }"
  [draggable]="false"
  [resizable]="false">

  <div class="flex flex-column gap-3 pt-2">
    <div class="flex flex-column gap-2">
      <label for="req-select" class="text-sm font-semibold text-color">Requisito *</label>
        <p-select
          inputId="req-select"
          [options]="requirementOptions()"
          [ngModel]="selectedRequirement()"
          (ngModelChange)="selectedRequirement.set($event)"
          optionLabel="description"
          optionValue="id"
          [filter]="true"
          (onFilter)="onFilterRequirements($event)"
          [loading]="loadingReqOptions()"
          emptyFilterMessage="Nenhum requisito encontrado"
          placeholder="Buscar e selecionar um requisito..."
          [showClear]="true"
          appendTo="body"
          class="w-full" />
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Cancelar"
      severity="secondary"
      [text]="true"
      [disabled]="savingReq()"
      (click)="showRequirementDialog.set(false)" />
    <p-button
      label="Salvar"
      icon="pi pi-check"
      [loading]="savingReq()"
      [disabled]="!selectedRequirement()"
      (click)="saveRequirement()" />
  </ng-template>
</p-dialog>

<!-- ─── Dialog: Adicionar / Editar Commit ────────────────────────────────────── -->
<p-dialog
  [visible]="showCommitDialog()"
  (visibleChange)="showCommitDialog.set($event)"
  [header]="editingCommitId() ? 'Editar Commit' : 'Adicionar Commit'"
  [modal]="true"
  [style]="{ width: '520px', maxWidth: 'calc(100vw - 2rem)' }"
  [breakpoints]="{ '768px': '95vw' }"
  [draggable]="false"
  [resizable]="false">

  <div class="flex flex-column gap-3 pt-2">
    <div class="flex flex-column gap-2">
      <label for="commit-id" class="text-sm font-semibold text-color">ID Commit *</label>
      <input
        id="commit-id"
        type="text"
        pInputText
        [ngModel]="formIdCommit()"
        (ngModelChange)="formIdCommit.set($event)"
        placeholder="Ex: a1b2c3d4e5f6..."
        maxlength="100"
        class="w-full" />
    </div>

    <div class="flex gap-3">
      <div class="flex flex-column gap-2 flex-1">
        <label for="commit-date" class="text-sm font-semibold text-color">Data *</label>
        <input
          id="commit-date"
          type="date"
          pInputText
          [ngModel]="formDate()"
          (ngModelChange)="formDate.set($event)"
          class="w-full" />
      </div>

      <div class="flex flex-column gap-2 flex-1">
        <label for="commit-version" class="text-sm font-semibold text-color">Versão</label>
        <input
          id="commit-version"
          type="text"
          pInputText
          [ngModel]="formVersion()"
          (ngModelChange)="formVersion.set($event)"
          placeholder="Ex: 1.2.0"
          maxlength="10"
          class="w-full" />
      </div>
    </div>

    <div class="flex flex-column gap-2">
      <label for="commit-obs" class="text-sm font-semibold text-color">Observações</label>
      <textarea
        id="commit-obs"
        pInputTextarea
        [ngModel]="formObservation()"
        (ngModelChange)="formObservation.set($event)"
        placeholder="Observações sobre o commit..."
        rows="3"
        class="w-full"></textarea>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Cancelar"
      severity="secondary"
      [text]="true"
      [disabled]="savingCommit()"
      (click)="showCommitDialog.set(false)" />
    <p-button
      label="Salvar"
      icon="pi pi-check"
      [loading]="savingCommit()"
      (click)="saveCommit()" />
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '480px' }" appendTo="body" />
